import { render, staticRenderFns } from "./renove.vue?vue&type=template&id=47080b9d&"
import script from "./renove.vue?vue&type=script&lang=ts&"
export * from "./renove.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports